<section class="contactsec mb-5">
  <div class="max-width-container pb-5 mb-5">
    <div class="container z-3 position-relative">
      <h2 class="lh-sm fw-bold mb-5">
        <span class="inhh">Our</span>
        Brand Directory
      </h2>
      <div class="table-head">
        <div class="position-relative">
          <span class="search-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M16.7499 16.75L13.4874 13.4875M15.25 9.25C15.25 12.5637 12.5637 15.25 9.25 15.25C5.93629 15.25 3.25 12.5637 3.25 9.25C3.25 5.93629 5.93629 3.25 9.25 3.25C12.5637 3.25 15.25 5.93629 15.25 9.25Z"
                stroke="#818898" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </span>
          <input type="text" placeholder="Search" class="form-control search-control" (input)="onSearch($event)" />
        </div>
      </div>
      <div class="d-flex flex-wrap flex-lg-nowrap align-items-center mb-5 gap-3">
        <button class="btn btn-secondary" type="button" (click)="filter('all')">All Brands</button>
        <div class="manageTab mb-0">
          <ul class="nav nav-pills p-2">
            <li class="nav-item py-0" *ngFor="let tab of tabs">
              <a class="nav-link py-2 px-3 rounded-circle shadow-none mx-1" [class.active]="activeTab === tab"
                role="button" (click)="filter(tab)">
                {{tab}}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="brand-content">
        <div *ngFor="let brand of filteredBrands; let i = index" class="brand-item">
          <div class="hbox" (click)="handleBrandClick(brand.id)">
            <div class="imgab">
              <img [src]="brand.logo || 'https://placehold.co/600x400?text=No+Logo' " alt="" />
            </div>
            <div class="subheadname">{{ brand.name }}</div>
          </div>
        </div>
      </div>
      <div class="text-center" *ngIf="filteredBrands.length === 0">
        <p>No matched results found </p>
      </div>
    </div>
  </div>
</section>